import React from "react";
import { Link } from "react-router-dom";
import * as LINKS from "../const/links";
import * as URLS from "../const/URL.const";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";


export const loginFormRows = (
  t: (key: string) => string
): IDynamicFormRow[] => {
  const forgottenPassword = () => (
    <div className="forgotten">
      <Link style={{color: "#616161", textDecoration:"none"}} to={URLS.FORGOT_PASSWORD_URL}>
        {t("forms.login.forgottenLink")}
      </Link>
    </div>
  );

  const content = () => (
    <p style={{fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1rem",
    margin:0,
    lineHeight: "1.5rem",
    color: "#757575",}}>
    {t("signup.form.terms_intro")}
    <a
      href={LINKS.TOS}
      target="_blank"
      rel="noopener noreferrer"
      style={{color: "#616161", textDecoration:"none"}}
    >
      {t("signup.form.tac")}
    </a>
  </p>
  )

  return [
    {
      label: "forms.login.username",
      keyName: "username",
      registerOptions: { required: true },
      Component: FormTextBox,
      formProps: {
        tooltip: "forms.login.usernameTooltip",
      },
    },
    {
      label: "forms.login.password",
      keyName: "password",
      registerOptions: { required: true },
      Component: FormTextBox,
      inputProperties: {
        type: "password",
        autoComplete: "current-password",
      },
    },
    { label: "", Component: forgottenPassword, keyName: "forgotten" },
    { label: "", Component: content, keyName: "tos" },
  ];
};
